import { render, staticRenderFns } from "./ShoppingCartCounter.vue?vue&type=template&id=6dcc8460"
import script from "./ShoppingCartCounter.vue?vue&type=script&lang=js"
export * from "./ShoppingCartCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports